import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { register as registerPushWorker } from './lib/push';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 10_000,
      refetchOnWindowFocus: true,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);

/*
 * Register the push worker, and ONLY register it.
 *
 * No permission is requested here. An unprompted notification dialog on first
 * load is the fastest way to a permanent block, and `Notification.permission
 * === 'denied'` cannot be re-requested from script — the operator would have to
 * go into browser or OS settings to undo a decision they made in half a second
 * about a page they had not read yet. Asking is the Account page's job, behind
 * a button they pressed. Registering early is still worth it: the worker has to
 * be active before a subscription can exist, and it also gives an already-open
 * tab something to be controlled by when a notification is tapped.
 */
void registerPushWorker();
